import _ from 'underscore';

import {assert} from 'Asserts';
import {RequestFulfillmentDefinition} from 'requests/fulfillments/FulfillmentConstants';
import sortFulfillments from 'requests/fulfillments/sortFulfillments';
import {Request} from 'requests/RequestConstants';

export function createFulfillmentDefinition({
  requestId,
  requestTaskId,
  sampleGroupId,
}: {
  requestId: string;
  requestTaskId: string | null;
  sampleGroupId: string | null;
}): RequestFulfillmentDefinition {
  return {
    requestId,
    requestTaskId,
    sampleGroupId,
    cid: `${requestId}-${requestTaskId}-${sampleGroupId}`,
  };
}

function getRequestFulfillmentDefinitions({
  requestId,
  requestTaskIds,
  requestSampleGroupIds,
  sampleGroupIdsByRequestTaskId,
}: {
  requestId: string;
  requestTaskIds: Array<string>;
  requestSampleGroupIds: Array<string>;
  sampleGroupIdsByRequestTaskId: {[requestTaskId: string]: Array<string>};
}): Array<RequestFulfillmentDefinition> {
  if (requestTaskIds.length === 0) {
    // There are no tasks - create one fulfillment definition per sample group
    return requestSampleGroupIds.map((sampleGroupId) =>
      createFulfillmentDefinition({requestId, requestTaskId: null, sampleGroupId})
    );
  }

  const fulfillmentDefinitions = [];
  for (const requestTaskId of requestTaskIds) {
    // Create one fulfillment definition per sample group of the task
    const taskSampleGroupIds = sampleGroupIdsByRequestTaskId[requestTaskId];
    assert(
      taskSampleGroupIds != null,
      'Sample group is not found in sampleGroupIdsByRequestTaskId. Most likely it was not loaded into ' +
        'the store.'
    );
    for (const sampleGroupId of taskSampleGroupIds) {
      fulfillmentDefinitions.push(createFulfillmentDefinition({requestId, requestTaskId, sampleGroupId}));
    }
  }
  return fulfillmentDefinitions;
}

export function createFulfillmentDefinitions({
  requests,
  requestTaskIdsByRequestId,
  sampleGroupIdsByRequestId,
  sampleGroupIdsByRequestTaskId,
}: {
  requests: Array<Request>;
  requestTaskIdsByRequestId: {[requestId: string]: Array<string>};
  sampleGroupIdsByRequestId: {[requestId: string]: Array<string>};
  sampleGroupIdsByRequestTaskId: {[requestTaskId: string]: Array<string>};
}): Array<RequestFulfillmentDefinition> | null {
  const fulfillmentDefinitions = [];
  for (const request of requests) {
    const requestTaskIds = requestTaskIdsByRequestId[request.id];
    const requestSampleGroupIds = sampleGroupIdsByRequestId[request.id];

    assert(
      requestTaskIds != null && requestSampleGroupIds != null && sampleGroupIdsByRequestTaskId != null,
      'One of the arguments is null. Most likely it was not loaded into the store.'
    );

    const requestFulfillmentDefinitions = getRequestFulfillmentDefinitions({
      requestId: request.id,
      requestTaskIds,
      requestSampleGroupIds,
      sampleGroupIdsByRequestTaskId,
    });
    if (requestFulfillmentDefinitions == null) {
      return null;
    }
    fulfillmentDefinitions.push(...requestFulfillmentDefinitions);
  }
  return sortFulfillments(fulfillmentDefinitions, {
    requestsById: _.indexBy(requests, 'id'),
    requestTaskIdsByRequestId,
    sampleGroupIdsByRequestId,
  });
}
